"use client";

import RemotionPlayer from "@/components/landing/RemotionPlayer";
import { AiReplyAnimation } from "@/remotion/features/AiReplyAnimation";
import { WhatsAppAnimation } from "@/remotion/features/WhatsAppAnimation";
import { OneTapAnimation } from "@/remotion/features/OneTapAnimation";
import { MultiLanguageAnimation } from "@/remotion/features/MultiLanguageAnimation";
import { DashboardAnimation } from "@/remotion/features/DashboardAnimation";
import { MultiLocationAnimation } from "@/remotion/features/MultiLocationAnimation";
import type { ComponentType } from "react";

const ANIMATIONS: { component: ComponentType; durationInFrames: number }[] = [
  { component: AiReplyAnimation, durationInFrames: 150 },
  { component: WhatsAppAnimation, durationInFrames: 150 },
  { component: OneTapAnimation, durationInFrames: 150 },
  { component: MultiLanguageAnimation, durationInFrames: 152 },
  { component: DashboardAnimation, durationInFrames: 150 },
  { component: MultiLocationAnimation, durationInFrames: 150 },
];

export default function FeatureAnimationPlayer({ index }: { index: number }) {
  const anim = ANIMATIONS[index];
  if (!anim) return null;
  return (
    <RemotionPlayer
      component={anim.component}
      durationInFrames={anim.durationInFrames}
    />
  );
}
